
import { defineComponent } from 'vue';
import { format as formatCurrency } from '@/lib/currency';

import CurrencyInput from '@/components/CurrencyInput.vue';
import Radio from '@/components/Radio.vue';
import { round } from 'lodash-es';

enum PayPeriod {
  Month,
  FourWeeks,
}

export default defineComponent({
  name: 'SalaryCalculator',
  props: {
    modelValue: Number,
  },
  components: { CurrencyInput, Radio },
  data() {
    return {
      PayPeriod,
      grossMonthlySalary: null,
      payPeriod: null,
      holidayPay: null,
      extraMonth: null,
    };
  },
  computed: {
    salary(): number | null {
      if (!this.isComplete) return null;

      // grossMonthlySalary can *not* be null as verified by complete
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const value = round(this.grossMonthlySalary! * this.months * (this.holidayPay ? 1.08 : 1), 2);
      this.$emit('update:modelValue', value);
      return value;
    },
    formattedSalary(): string {
      return this.salary !== null ? formatCurrency(this.salary) : '';
    },
    isComplete(): boolean {
      return this.grossMonthlySalary !== null
          && this.payPeriod !== null
          && this.holidayPay !== null
          && (this.extraMonth !== null || this.payPeriod === PayPeriod.FourWeeks);
    },
    months(): number {
      if (this.payPeriod === null) {
        return 0;
      }

      if (this.payPeriod === PayPeriod.FourWeeks) {
        return 13;
      }

      return 12 + (this.extraMonth === true ? 1 : 0);
    },
  },
});
